import React from "react";
import PropTypes from "prop-types";
import { ExpenseModalInner } from "./ExpenseModalInner.js";

export const ExpenseModal = ({ open, ...rest }) => {
  return (
    //(open is here as question just to reset state inside modal)
    open && (
      <ExpenseModalInner
        open={open}
        {...rest}
      />
    )
  );
};

ExpenseModal.propTypes = {
  open: PropTypes.bool,
};
